import React from 'react';
import Details from './Details';
const DetailsLoader = (props) => {
    return React.createElement(Details, Object.assign({}, props));
};
export default DetailsLoader;
